import React from 'react';

function Footer() {
  return (
    <footer className="flex-col sm:flex-row items-center p-6 bg-yellow-200 flex  gap-5 sm:gap-16 md:gap-32 md:justify-around xl:justify-between xl:px-40">
      <div className="flex-col items-center md:justify-center  ">
        <h5 className="text-2xl lg:text-3xl font-bold text-center">
          Subscribe
        </h5>

        <p className=" text-sm md:text-base lg:text-lg xl:text-xl block mt-2 text-center">
          We&apos;ll never to spam you or share your email
        </p>
        <div className="form-control w-80 items-center lg:ml-4 xl:ml-8 ">
          <div className="relative pt-6 sm:w-64 lg:w-96 ">
            <input
              type="text"
              placeholder="Enter your e-mail"
              className="input input-bordered w-full pr-16 "
            />
            <button
              className=" btn btn-primary absolute top--6 right-0 rounded-l-none"
              type="submit"
            >
              Enter
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-around mt-2 sm:mt-8 md:m-0 gap-10 items-center">
        <div className="mx-3 font-bold flex justify-end gap-5 lg:gap-10 md:text-lg lg:text-xl  ">
          <a href="/">Home</a>
          <a href="/blogs">Blogs</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
          <a href="/team">Team</a>
        </div>
        <div className="flex flex-row gap-10 lg:gap-16">
          <a href="https://twitter.com">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
            </svg>
          </a>
          <a href="https://youtube.com">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
            </svg>
          </a>
          <a href="https://facebook.com">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
